exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-4f5dc342]{cursor:pointer}.none[data-v-4f5dc342]:after{display:inline-block;content:\"\\2BC1\";opacity:.25;transform:scaleY(1.4)}.asc[data-v-4f5dc342]:after,.desc[data-v-4f5dc342]:after{display:inline-block;content:\"\\25B2\"}.desc[data-v-4f5dc342]:after{transform:rotate(180deg)}", ""]);

// exports
